import { useRole } from "redux/auth";

type TProps = {
  children: React.ReactNode;
  blacklistRoles?: string[];
  whitelistRoles?: string[];
};
function RoleChecker({ children, blacklistRoles, whitelistRoles }: TProps) {
  const role = useRole();

  if (!role) return null;
  if (blacklistRoles && blacklistRoles.includes(role)) return null;
  if (whitelistRoles && !whitelistRoles.includes(role)) return null;

  return <>{children}</>;
}

export default RoleChecker;
